import React, { useState } from 'react';

import { useRouter } from 'expo-router';
import { KeyboardController } from 'react-native-keyboard-controller';

import ActionButton from 'components/action-button';
import { CardModal } from 'components/card-modal';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { useLoyaltyClaimPointsContext } from 'state/loyalty-claim-points';
import { spacing } from 'styles/constants';

import {
  InstructionDateText,
  MainImage,
  StyledLink,
  Text,
  Title,
  TransactionDateInputFormContainer,
} from './loyalty-claim-points.styled';
import TransactionDateInputForm from './transaction-form/transaction-date-input-form';
import TransactionInputForm from './transaction-form/transaction-input-form';
import { ClaimMethod } from './types';
import { generateTransactionDateOptions } from './utils';

const TRANSACTION_ID_MIN_LENGTH = 20;

const LoyaltyClaimPointsSurvey = () => {
  const { data } = useLoyaltyClaimPointsContext();
  const { replace } = useRouter();
  const isMobile = useIsMobileBreakpoint();
  const [codeValue, setCodeValue] = useState('');
  const [transactionDate, setTransactionDate] = useState<string>('');

  const content = data?.claimPointsSurveyContent;
  const expirationTimeAvailable = Boolean(
    content?.expirationTimeReceipts && content.inputBoxExpirationDatePlaceholder?.locale
  );
  const isSubmitDisable =
    codeValue.length < TRANSACTION_ID_MIN_LENGTH || (expirationTimeAvailable && !transactionDate);

  const submit = () => {
    const url = content?.topButtonUrl?.locale
      ? `${content.topButtonUrl.locale}?code=${codeValue}${
          expirationTimeAvailable ? `&transaction_date=${transactionDate}` : ''
        }&method=${ClaimMethod.MANUAL}`
      : '/';

    replace(url);
  };

  const handleTransactionInputSubmitEditing = () => {
    void KeyboardController.dismiss();
  };

  const bottomButtonUrl = content?.bottomButtonUrl?.locale;
  const bottomButtonTitle = content?.bottomButtonTitle?.locale;

  return (
    <CardModal
      standardPadding
      dismissType="back"
      alwaysShowHeader
      scrollView
      keyboardAwareFooter
      footer={
        <ActionButton fullWidth disabled={isSubmitDisable} onPress={submit}>
          {content?.topButtonTitle?.locale}
        </ActionButton>
      }
    >
      {content?.rewardsIcon && (
        <MainImage
          alt={content.screenTitle?.locale || ''}
          image={content.rewardsIcon.locale}
          height="50px"
        />
      )}
      <Title>{content?.screenTitle?.locale}</Title>
      <Text
        focusable
        content={content?.instructionsTextBlock?.localeRaw}
        textAlign={{ md: 'center' }}
      />
      {content?.secondImage && (
        <MainImage
          m="$4"
          alt={content.screenTitle?.locale || ''}
          image={content.secondImage?.locale}
          height="200px"
        />
      )}
      <TransactionInputForm
        setCodeValue={setCodeValue}
        onSubmitEditing={handleTransactionInputSubmitEditing}
      />

      {expirationTimeAvailable && (
        <TransactionDateInputFormContainer>
          <InstructionDateText
            focusable
            content={content?.expirationDateInstructionsTextBlock?.localeRaw}
          />
          <TransactionDateInputForm
            title={content?.inputBoxExpirationDatePlaceholder?.locale || ''}
            options={generateTransactionDateOptions({
              validReceiptHours: content?.expirationTimeReceipts || 0,
              currentDate: Date.now(),
            })}
            onChange={setTransactionDate}
          />
        </TransactionDateInputFormContainer>
      )}
      {isMobile && bottomButtonTitle && bottomButtonUrl && (
        <StyledLink to={bottomButtonUrl} style={{ marginTop: spacing.$4 }}>
          {bottomButtonTitle}
        </StyledLink>
      )}
    </CardModal>
  );
};

export default LoyaltyClaimPointsSurvey;
